import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleBack } from "../../../utils/backButton";

const Error400 = () => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => ({
    role: state.auth.role,
  }));

  return (
    <div className="fix-wrapper">
      <div className="container">
        {" "}
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text fw-bold">400</h1>
              <h4>
                <i className="fa fa-thumbs-down text-danger" /> Bad Request
              </h4>
              <p>Your Request resulted in an error</p>
              <div>
                <button
                  onClick={() => handleBack(role, navigate)}
                  className="btn btn-primary"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error400;
